import React from "react";
import SEO from "../common/SEO";
import "../assets/css/style.css";

const MobileAppDevelopment = () => {
  return (
    <>
      <SEO title="Mobile App Development" />
      <div>
        <section class="top-apps">
          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="top-app-heading">
                  <h2>Top-rated mobile app development company</h2>
                  <p>
                    When marketing your app, it has to be a unique one. At Odhav
                    Technologies, we provide unparalleled solutions, steering
                    your product towards success. As a pro-convergence app
                    development company, we employ agile methodology in our
                    projects and offer human-centric mobile app solutions by
                    synergizing UX, smart consultation, bots, AIs, IoT and other
                    latest technologies in the market. With being top app
                    developers India, our team consists of highly experienced
                    professionals with years of industry exposure, helping
                    clients generate desired results within the stipulated time
                    and budget
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 align-self-center">
                <div class="top-app-img">
                  <div
                    class="item-right-top aos-init aos-animate"
                    data-aos="fade-down-left"
                  >
                    <div class="item-box-top"></div>
                  </div>
                  <div
                    class="item-right-down aos-init aos-animate"
                    data-aos="fade-up-left"
                  >
                    <div class="item-box-down"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="AfterHomeCaseStudies"
          class="mobile-app-sec-6 mobile-app-new-york-sec-6 mobile-app-responsive white-bg-info mobile-app-development-we-develop aos-init aos-animate"
          data-aos="fade-up"
        >
          <div class="container-fluid p-0">
            <div class="row m-0 justify-content-center">
              <div class="col-12">
                <div class="commontext text-black text-center">
                  <h2 class="h3 mb-5">Our Mobile App Development Services</h2>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 align-end border-end pad_box">
                <a href="#">
                  <div class="card-box box-container box-dark on-hover-show-content">
                    <div class="box-top commontext">
                      <h3 class="h2">Flutter App Development</h3>
                    </div>
                    <div class="box-bottom">
                      <div class="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 50 50"
                          width="50px"
                          height="50px"
                        >
                          <path d="M 27 3 A 1.0001 1.0001 0 0 0 26.292969 3.2929688 L 5.2929688 24.292969 A 1.0001 1.0001 0 0 0 5.2929688 25.707031 L 11.292969 31.707031 A 1.0001 1.0001 0 0 0 12.707031 31.707031 L 39.707031 4.7070312 A 1.0001 1.0001 0 0 0 39 3 L 27 3 z M 27.414062 5 L 36.585938 5 L 12 29.585938 L 7.4140625 25 L 27.414062 5 z M 28 22 A 1.0001 1.0001 0 0 0 27.292969 22.292969 L 15.292969 34.292969 A 1.0001 1.0001 0 0 0 15.292969 35.707031 L 21.292969 41.707031 L 27.292969 47.707031 A 1.0001 1.0001 0 0 0 28 48 L 40 48 A 1.0001 1.0001 0 0 0 40.707031 46.292969 L 29.414062 35 L 40.707031 23.707031 A 1.0001 1.0001 0 0 0 40 22 L 28 22 z M 28.414062 24 L 37.585938 24 L 22 39.585938 L 17.414062 35 L 28.414062 24 z M 28 36.414062 L 37.585938 46 L 28.414062 46 L 23.414062 41 L 28 36.414062 z" />
                        </svg>
                      </div>
                    </div>
                    <div class="card-box-footer">
                      <div class="info">
                        <p class="hover-text">
                          We develop hybrid android and iOS apps by following
                          the Human Interface Guidelines. Flutter allows for
                          building high-performance, cross-platform apps for
                          iOS, Android, and the web using a single codebase.
                        </p>
                      </div>
                    </div>
                    <div class="card-blur"></div>
                  </div>
                </a>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 align-end border-end pad_box">
                <a href="#">
                  <div class="card-box box-container box-dark on-hover-show-content">
                    <div class="box-top commontext">
                      <h3 class="h2">Android App Development</h3>
                    </div>
                    <div class="box-bottom">
                      <div class="icon">
                        <svg
                          version="1.1"
                          viewBox="0 0 57.001 57.001"
                          width="50px"
                          height="50px"
                        >
                          <path
                            d="M35.361,5.677l2.497-4.162c0.284-0.474,0.131-1.088-0.343-1.372c-0.475-0.285-1.088-0.132-1.372,0.343l-2.635,4.392    c-1.569-0.558-3.249-0.878-5.007-0.878s-3.438,0.32-5.007,0.878l-2.635-4.392c-0.284-0.475-0.898-0.627-1.372-0.343    s-0.627,0.898-0.343,1.372l2.497,4.162c-4.827,2.495-8.14,7.525-8.14,13.324c0,0.553,0.448,1,1,1h28c0.552,0,1-0.447,1-1    C43.5,13.203,40.188,8.173,35.361,5.677z M15.539,18.001c0.512-6.703,6.13-12,12.962-12s12.45,5.297,12.962,12H15.539z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M35.478,11.364H34.16c-0.364,0-0.659,0.295-0.659,0.659v1.318c0,0.364,0.295,0.659,0.659,0.659h1.319    c0.364,0,0.659-0.295,0.659-0.659v-1.318C36.138,11.659,35.842,11.364,35.478,11.364z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M22.841,11.364h-1.319c-0.364,0-0.659,0.295-0.659,0.659v1.318c0,0.364,0.295,0.659,0.659,0.659h1.319    c0.364,0,0.659-0.295,0.659-0.659v-1.318C23.5,11.659,23.205,11.364,22.841,11.364z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M42.5,21.001h-28c-0.552,0-1,0.447-1,1v20.171c0,2.663,2.169,4.829,4.834,4.829H19.5v6.006c0,2.202,1.794,3.994,4,3.994    s4-1.792,4-3.994v-6.006h2v6.006c0,2.202,1.794,3.994,4,3.994s4-1.792,4-3.994v-6.006h1.166c2.666,0,4.834-2.166,4.834-4.829    V22.001C43.5,21.448,43.053,21.001,42.5,21.001z M41.5,42.172c0,1.56-1.271,2.829-2.834,2.829H36.5c-0.552,0-1,0.447-1,1v7.006    c0,1.1-0.897,1.994-2,1.994s-2-0.895-2-1.994v-7.006c0-0.553-0.448-1-1-1h-4c-0.552,0-1,0.447-1,1v7.006    c0,1.1-0.897,1.994-2,1.994s-2-0.895-2-1.994v-7.006c0-0.553-0.448-1-1-1h-2.165c-1.563,0-2.835-1.27-2.835-2.829V23.001h26    V42.172z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M48,21.001c-1.93,0-3.5,1.572-3.5,3.504v13.992c0,1.932,1.57,3.504,3.5,3.504s3.5-1.572,3.5-3.504V24.505    C51.5,22.573,49.93,21.001,48,21.001z M49.5,38.497c0,0.829-0.673,1.504-1.5,1.504s-1.5-0.675-1.5-1.504V24.505    c0-0.829,0.673-1.504,1.5-1.504s1.5,0.675,1.5,1.504V38.497z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M9,21.001c-1.93,0-3.5,1.572-3.5,3.504v13.992c0,1.932,1.57,3.504,3.5,3.504s3.5-1.572,3.5-3.504V24.505    C12.5,22.573,10.93,21.001,9,21.001z M10.5,38.497c0,0.829-0.673,1.504-1.5,1.504s-1.5-0.675-1.5-1.504V24.505    c0-0.829,0.673-1.504,1.5-1.504s1.5,0.675,1.5,1.504V38.497z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div class="card-box-footer">
                      <div class="info">
                        <p class="hover-text">
                          We develop high-end Android apps by following the
                          Material Design Guidelines and harness the best
                          knowledge on Android libraries.
                        </p>
                      </div>
                    </div>
                    <div class="card-blur"></div>
                  </div>
                </a>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 align-end border-end pad_box">
                <a href="#">
                  <div class="card-box box-container box-dark on-hover-show-content">
                    <div class="box-top commontext">
                      <h3 class="h2">React Native App Development</h3>
                    </div>
                    <div class="box-bottom">
                      <div class="icon">
                        <svg
                          version="1.1"
                          viewBox="0 0 470 470"
                          enable-background="new 0 0 470 470"
                          width="50px"
                          height="50px"
                        >
                          <path
                            d="m398.559,166.02c-8.85-3.404-18.292-6.493-28.22-9.265 2.563-9.984 4.609-19.706 6.087-29.073 7.689-48.757-0.808-82.959-23.925-96.306-6.72-3.88-14.443-5.848-22.954-5.848-26.882,0-60.85,19.965-95.118,53.681-7.486-7.352-15.006-14.105-22.502-20.167-38.379-31.038-72.25-40.781-95.365-27.434-14.856,8.577-23.891,26.093-26.126,50.652-0.376,4.125 2.664,7.773 6.789,8.148 4.138,0.382 7.772-2.664 8.148-6.789 1.238-13.594 5.484-31.398 18.688-39.021 17.11-9.881 45.699-0.365 78.434,26.106 7.143,5.776 14.314,12.217 21.461,19.233-14.373,15.293-28.676,32.894-42.41,52.347-24.16,2.199-47.172,5.888-68.291,10.948-3.698-14.376-6.238-28.093-7.491-40.827-0.405-4.122-4.059-7.134-8.198-6.729-4.122,0.405-7.135,4.076-6.729,8.198 1.326,13.474 4.008,27.966 7.917,43.133-9.596,2.706-18.73,5.712-27.311,9.012-46.072,17.72-71.443,42.18-71.443,68.873s25.371,51.153 71.441,68.872c8.85,3.404 18.292,6.493 28.22,9.265-2.563,9.984-4.609,19.706-6.087,29.073-7.689,48.757 0.808,82.959 23.925,96.306 6.72,3.88 14.443,5.848 22.954,5.848 26.573,0 60.071-19.516 93.938-52.531 7.255,7.086 14.54,13.609 21.803,19.482 27.161,21.966 52.059,33.266 72.489,33.265 8.438-0.001 16.119-1.93 22.876-5.831 23.117-13.347 31.614-47.549 23.925-96.306-1.477-9.366-3.523-19.087-6.086-29.07 15.439-4.252 29.64-9.26 42.218-14.96 3.773-1.71 5.445-6.154 3.735-9.927-1.71-3.773-6.155-5.446-9.927-3.735-11.912,5.398-25.377,10.15-40.042,14.192-6.063-20.261-14.137-41.412-23.976-62.808 10.281-22.122 18.685-44.004 24.943-64.936 55.665,15.586 88.651,40.202 88.651,63.801 0,15.247-13.296,27.827-24.45,35.694-3.385,2.388-4.193,7.067-1.806,10.452 2.388,3.386 7.067,4.193 10.452,1.806 20.153-14.215 30.804-30.797 30.804-47.952 0-26.693-25.371-51.153-71.441-68.872zm-69.013-125.491c5.844,7.10543e-15 11.044,1.291 15.454,3.838 17.112,9.88 23.166,39.396 16.607,80.979-1.405,8.907-3.35,18.159-5.789,27.669-21.207-5.028-44.299-8.68-68.532-10.835-13.596-19.242-27.866-36.839-42.375-52.253 2.655-2.618 5.312-5.158 7.964-7.602 29.252-26.953 56.48-41.796 76.671-41.796zm-95.096,60.152c11.317,12.062 22.5,25.517 33.323,40.102-10.769-0.587-21.712-0.891-32.773-0.891-11.431,0-22.738,0.321-33.855,0.947 10.808-14.56 22.006-28.07 33.305-40.158zm-.053,269.657c-11.718-12.42-23.296-26.341-34.486-41.466 11.514,0.674 23.234,1.02 35.089,1.02 11.419,0 22.732-0.333 33.871-0.969-11.18,15.064-22.777,29.01-34.474,41.415zm.603-55.446c-16.115,0-31.578-0.624-46.314-1.784-8.277-12.076-16.284-24.78-23.907-37.984-7.503-12.995-14.405-26.107-20.657-39.155 6.49-13.661 13.707-27.412 21.596-41.077 7.64-13.232 15.75-26.063 24.177-38.307 14.374-1.099 29.429-1.693 45.105-1.693 15.273,0 29.956,0.564 43.994,1.609 8.434,12.267 16.59,25.185 24.349,38.623 7.85,13.597 15.034,27.279 21.5,40.873-6.219,12.942-13.091,25.957-20.56,38.894-7.625,13.207-15.72,26.015-24.13,38.239-14.716,1.158-29.83,1.762-45.153,1.762zm-65.615-3.655c-18.453-2.132-35.582-5.129-51.205-8.81 4.744-15.789 10.758-32.16 17.929-48.79 4.898,9.688 10.128,19.373 15.679,28.987 5.668,9.818 11.549,19.371 17.597,28.613zm1.19-152.829c-6.111,9.318-12.078,18.991-17.847,28.984-5.933,10.276-11.499,20.61-16.677,30.928-7.543-17.318-13.858-34.376-18.788-50.749 16.203-3.859 34.042-6.983 53.312-9.163zm-155.575,76.484c0-23.472 32.634-47.951 87.757-63.55 6.235,20.802 14.601,42.62 24.805,64.647-9.813,21.362-17.865,42.477-23.913,62.705-55.663-15.587-88.649-40.203-88.649-63.802zm125.454,194.363c-5.844,0-11.044-1.291-15.454-3.838-17.112-9.88-23.166-39.396-16.607-80.979 1.405-8.907 3.35-18.159 5.789-27.669 20.518,4.865 42.8,8.441 66.173,10.619 13.951,19.807 28.618,37.883 43.53,53.648-2.254,2.201-4.509,4.348-6.76,6.423-29.252,26.954-56.48,41.796-76.671,41.796zm220.214-84.584c6.559,41.583 0.505,71.099-16.607,80.979-17.113,9.879-45.699,0.364-78.434-26.106-6.893-5.574-13.814-11.767-20.712-18.499 14.761-15.578 29.462-33.603 43.563-53.579 23.432-2.151 45.822-5.697 66.389-10.509 2.445,9.526 4.394,18.793 5.801,27.714zm-9.83-42.153c-16.064,3.733-33.311,6.67-51.339,8.745 6.085-9.283 12.027-18.918 17.773-28.871 5.517-9.556 10.713-19.161 15.579-28.757 7.195,16.66 13.228,33.063 17.987,48.883zm-17.918-84.145c-5.152-10.259-10.688-20.532-16.587-30.749-5.818-10.078-11.859-19.878-18.077-29.348 19.355,2.146 37.276,5.243 53.564,9.081-4.955,16.493-11.302,33.623-18.9,51.016z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#000000"
                            fill="#000000"
                          ></path>
                          <path
                            d="m235,197.392c-20.678,0-37.5,16.822-37.5,37.5s16.822,37.5 37.5,37.5 37.5-16.822 37.5-37.5-16.822-37.5-37.5-37.5zm0,60c-12.406,0-22.5-10.094-22.5-22.5s10.094-22.5 22.5-22.5 22.5,10.094 22.5,22.5-10.094,22.5-22.5,22.5z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#000000"
                            fill="#000000"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div class="card-box-footer">
                      <div class="info">
                        <p class="hover-text">
                          With code reusability, cross-platform support and a
                          native-like UI, we develop react native apps that are
                          cost-effective and give better ROI. Talk to our
                          certified React native app developers.
                        </p>
                      </div>
                    </div>
                    <div class="card-blur"></div>
                  </div>
                </a>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 align-end border-end pad_box">
                <a href="#">
                  <div class="card-box box-container box-dark on-hover-show-content">
                    <div class="box-top commontext">
                      <h3 class="h2">Enterprise Mobile Solutions</h3>
                    </div>
                    <div class="box-bottom">
                      <div class="icon">
                        <svg
                          version="1.1"
                          viewBox="0 0 60 60"
                          width="50px"
                          height="50px"
                        >
                          <path
                            d="M20,49c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S22.206,49,20,49z M20,55c-1.103,0-2-0.897-2-2s0.897-2,2-2   s2,0.897,2,2S21.103,55,20,55z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M17,5h4c0.552,0,1-0.447,1-1s-0.448-1-1-1h-4c-0.552,0-1,0.447-1,1S16.448,5,17,5z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M24,5h1c0.552,0,1-0.447,1-1s-0.448-1-1-1h-1c-0.552,0-1,0.447-1,1S23.448,5,24,5z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M56,12H38V4.405C38,1.977,36.024,0,33.595,0H8.405C5.976,0,4,1.977,4,4.405v51.189C4,58.023,5.976,60,8.405,60h25.189   C36.024,60,38,58.023,38,55.595V33h18V12z M8.405,2h25.189C34.921,2,36,3.079,36,4.405V6H6V4.405C6,3.079,7.079,2,8.405,2z    M33.595,58H8.405C7.079,58,6,56.921,6,55.595V48h30v7.595C36,56.921,34.921,58,33.595,58z M36,46H6V8h30v4H18v21h4v7l9.333-7H36   V46z M54,31H38h-7.333L24,36v-5h-4V14h18h16V31z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M25,21h10c0.552,0,1-0.447,1-1s-0.448-1-1-1H25c-0.552,0-1,0.447-1,1S24.448,21,25,21z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                          <path
                            d="M24,25c0,0.553,0.448,1,1,1h24c0.552,0,1-0.447,1-1s-0.448-1-1-1H25C24.448,24,24,24.447,24,25z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#ffffff"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div class="card-box-footer">
                      <div class="info">
                        <p class="hover-text">
                          We are one of the very few application development
                          companies that deliver complex projects within the
                          stipulated time. We make the impossible happen,
                          offering the best mobile app development in India.
                        </p>
                      </div>
                    </div>
                    <div class="card-blur"></div>
                  </div>
                </a>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="text-message-info commontext text-black text-center pt-2">
                  <a
                    class="button-4 border-black mx-auto mb-4 mb-xl-5 mb-lg-5 mb-md-5 mb-sm-3"
                    href="/contact"
                  >
                    <div class="eff-4"></div>
                    <span>Talk To Us!</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="mobile-app-sec-3 mobile-app-new-york-sec-3 black-bg-info">
          <div class="container">
            <div class="row justify-content-left">
              <div class="col-sm-12 col-md-10 col-lg-8 col-xl-7">
                <div class="message-text-wrap">
                  <div class="text-message-info commontext text-white">
                    <h2 class="h3" style={{ color: "#d1d1d1" }}>
                      How Odhav technologies, #1 app developer in India, makes
                      your app idea a reality?
                    </h2>
                    <p class="mb-5">
                      We believe in creating value for our customers. And
                      pre-planning is the best way to start. We conduct
                      stakeholder interviews and address their needs. We
                      identify their target audience, prospects, budget, and
                      schedules. Our team of app developers and designers in the
                      breathtaking Madison Avenue, Manhattan, plan the optimum
                      requirements to carry out the individual processes. Not
                      only that, we test several functionalities to see which
                      one suits best. This helps our clients to receive the best
                      without having to compromise on their vision. Credit goes
                      to the agile app development process we follow.
                    </p>
                    <h5 class="text-uppercase">
                      Don’t believe us? Check out our{" "}
                      <a
                        class="text-white text-underline"
                        href="https://odhavtechnologies.com/projects/"
                      >
                        works!
                      </a>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wirefram-img-wrap">
            <div class="row">
              <div class="col-sm-12">
                <div class="design-box mb-xl-3 mb-lg-3 mb-md-3">
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                    /images/high-fidelity-wireframe-nyc@4x.png,
                                    /images/high-fidelity-wireframe-nyc@2x.png,
                                    /images/high-fidelity-wireframe-nyc@1.5x.png,
                                    /images/high-fidelity-wireframe-nyc@1x.png,
                                    /images/high-fidelity-wireframe-nyc@0.75x.png
                                    "
                    src="/images/high-fidelity-wireframe-nyc@2x.png"
                    alt="app developers India"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="wirefram-mobileimg-wrap">
            <div class="swiper-container swiper-container-initialized swiper-container-horizontal">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index="2"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Payment-for-Subscription@4x.png,
                                /images/Payment-for-Subscription@2x.png,
                                /images/Payment-for-Subscription@1.5x.png,
                                /images/Payment-for-Subscription@1x.png,
                                /images/Payment-for-Subscription@0.75x.png
                                "
                    src="/images/Payment-for-Subscription@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index="3"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Personalisation@4x.png,
                                /images/Personalisation@2x.png,
                                /images/Personalisation@1.5x.png,
                                /images/Personalisation@1x.png,
                                /images/Personalisation@0.75x.png
                                "
                    src="/images/Personalisation@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index="4"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Personalisation_01@4x.png,
                                /images/Personalisation_01@2x.png,
                                /images/Personalisation_01@1.5x.png,
                                /images/Personalisation_01@1x.png,
                                /images/Personalisation_01@0.75x.png
                                "
                    src="/images/Personalisation_01@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-duplicate swiper-slide-prev"
                  data-swiper-slide-index="5"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Write_a_review@4x.png,
                                /images/Write_a_review@2x.png,
                                /images/Write_a_review@1.5x.png,
                                /images/Write_a_review@1x.png,
                                /images/Write_a_review@0.75x.png
                                "
                    src="/images/Write_a_review@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-active"
                  data-swiper-slide-index="0"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Personalisation_05@4x.png,
                                /images/Personalisation_05@2x.png,
                                /images/Personalisation_05@1.5x.png,
                                /images/Personalisation_05@1x.png,
                                /images/Personalisation_05@0.75x.png
                                "
                    src="/images/Personalisation_05@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-next"
                  data-swiper-slide-index="1"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Main-Home@4x.png,
                                /images/Main-Home@2x.png,
                                /images/Main-Home@1.5x.png,
                                /images/Main-Home@1x.png,
                                /images/Main-Home@0.75x.png
                                "
                    src="/images/Main-Home@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide"
                  data-swiper-slide-index="2"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Payment-for-Subscription@4x.png,
                                /images/Payment-for-Subscription@2x.png,
                                /images/Payment-for-Subscription@1.5x.png,
                                /images/Payment-for-Subscription@1x.png,
                                /images/Payment-for-Subscription@0.75x.png
                                "
                    src="/images/Payment-for-Subscription@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide"
                  data-swiper-slide-index="3"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Personalisation@4x.png,
                                /images/Personalisation@2x.png,
                                /images/Personalisation@1.5x.png,
                                /images/Personalisation@1x.png,
                                /images/Personalisation@0.75x.png
                                "
                    src="/images/Personalisation@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide"
                  data-swiper-slide-index="4"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Personalisation_01@4x.png,
                                /images/Personalisation_01@2x.png,
                                /images/Personalisation_01@1.5x.png,
                                /images/Personalisation_01@1x.png,
                                /images/Personalisation_01@0.75x.png
                                "
                    src="/images/Personalisation_01@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-duplicate-prev"
                  data-swiper-slide-index="5"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Write_a_review@4x.png,
                                /images/Write_a_review@2x.png,
                                /images/Write_a_review@1.5x.png,
                                /images/Write_a_review@1x.png,
                                /images/Write_a_review@0.75x.png
                                "
                    src="/images/Write_a_review@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                  data-swiper-slide-index="0"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Personalisation_05@4x.png,
                                /images/Personalisation_05@2x.png,
                                /images/Personalisation_05@1.5x.png,
                                /images/Personalisation_05@1x.png,
                                /images/Personalisation_05@0.75x.png
                                "
                    src="/images/Personalisation_05@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                  data-swiper-slide-index="1"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Main-Home@4x.png,
                                /images/Main-Home@2x.png,
                                /images/Main-Home@1.5x.png,
                                /images/Main-Home@1x.png,
                                /images/Main-Home@0.75x.png
                                "
                    src="/images/Main-Home@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index="2"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Payment-for-Subscription@4x.png,
                                /images/Payment-for-Subscription@2x.png,
                                /images/Payment-for-Subscription@1.5x.png,
                                /images/Payment-for-Subscription@1x.png,
                                /images/Payment-for-Subscription@0.75x.png
                                "
                    src="/images/Payment-for-Subscription@2x.png"
                    alt="app developers India"
                  />
                </div>
                <div
                  class="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index="3"
                  style={{ width: "163.75px", marginRight: "60px" }}
                >
                  <img
                    class="blur-out"
                    data-sizes="xl, l, m, s, xs"
                    data-srcset="
                                /images/Personalisation@4x.png,
                                /images/Personalisation@2x.png,
                                /images/Personalisation@1.5x.png,
                                /images/Personalisation@1x.png,
                                /images/Personalisation@0.75x.png
                                "
                    src="/images/Personalisation@2x.png"
                    alt="app developers India"
                  />
                </div>
              </div>
              <span
                class="swiper-notification"
                aria-live="assertive"
                aria-atomic="true"
              ></span>
            </div>
            <div class="swiper-scrollbar">
              <div
                class="swiper-scrollbar-drag"
                style={{
                  transform: "translate3d(167.299px, 0px, 0px)",
                  transitionDuration: "0ms",
                  width: "0px",
                }}
              ></div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MobileAppDevelopment;
